import { areAnalyticsCookiesEnabled, registerOnAllowCookieCallback } from "@edaz/utils/cookies";
import ReactGA from "react-ga";
import { gaDebug, gaId } from "../config";

function initialize() {
  ReactGA.initialize(gaId, {
    debug: gaDebug,
  });

  ReactGA.plugin.require("ecommerce");
}

export default function initializeAnalytics() {
  if (areAnalyticsCookiesEnabled()) {
    initialize();
  } else {
    registerOnAllowCookieCallback("analytics", initialize);
  }
}
